import { render, staticRenderFns } from "./RateSchedulePopover.vue?vue&type=template&id=2bb2c658&"
import script from "./RateSchedulePopover.vue?vue&type=script&lang=ts&"
export * from "./RateSchedulePopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports